import { INCOME_TYPES } from '@constants/ssap/hhmTypes/incomeAndExpenceTypes';

/**
 * @param {unknown} sourceName income `sourceName` / employer name field
 * @returns {boolean} true when employer/source name is missing or blank
 */

export const isIncomeSourceNameMissing = sourceName =>
    sourceName === null || (typeof sourceName === 'string' && sourceName.trim() === '');

/**
 * JOB income with no employer/source name.
 * @param {object} income single income from `householdMember.incomes[]`
 * @returns {boolean}
 */
export const isJobIncomeRowMissingEmployerName = income =>
    income?.type === INCOME_TYPES.JOB && isIncomeSourceNameMissing(income.sourceName);

/**
 * @param {object} data SSAP application data (`state.ssap.data`)
 * @returns {number | null} index of the first householdMember with a JOB income missing sourceName; null if none
 */
export const getFirstHhmIdxWithJobIncomeMissingEmployerName = data => {
    const members = data?.taxHousehold?.householdMember;

    if(!Array.isArray(members)) {
        return null;
    }

    const hhmIdx = members.findIndex(member => {
        const { incomes } = member || {};

        if(!Array.isArray(incomes)) {
            return false;
        }

        return incomes.some(income => isJobIncomeRowMissingEmployerName(income));
    });

    return hhmIdx === -1 ? null : hhmIdx;
};
